import { apiClient } from './client';

export interface Theme {
  id: string;
  slug: string;
  title: string;
  description?: string;
  created_at: string;
}

export interface Topic {
  id: string;
  theme_id?: string;
  slug: string;
  title: string;
  summary?: string;
  order_index: number;
  created_at: string;
  theme?: Theme;
  sections?: Section[];
  flashcards?: Flashcard[];
  questions?: Question[];
}

export interface Section {
  id: string;
  topic_id: string;
  heading: string;
  body_md: string;
  order_index: number;
  questions?: Question[];
}

export interface Flashcard {
  id: string;
  topic_id: string;
  front: string;
  back: string;
  order_index: number;
}

export interface Question {
  id: string;
  topic_id: string;
  section_id?: string;
  question: string;
  choice_a: string;
  choice_b: string;
  choice_c: string;
  choice_d: string;
  answer: 'A' | 'B' | 'C' | 'D';
  explanation?: string;
  order_index: number;
}

export interface SearchResult {
  topics: Topic[];
  sections: Section[];
  flashcards: Flashcard[];
  questions: Question[];
}

export const topicsApi = {
  // Get all topics
  getAll: async (): Promise<Topic[]> => {
    try {
      const response = await apiClient.get('/master/topics');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch topics from API:', error);
      throw error;
    }
  },

  // Get topic by slug
  getBySlug: async (slug: string): Promise<Topic> => {
    try {
      const response = await apiClient.get(`/master/topics/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch topic ${slug} from API:`, error);
      throw error;
    }
  },

  // Get topic quiz
  getQuiz: async (topicId: string): Promise<Question[]> => {
    try {
      const response = await apiClient.get(`/master/topics/${topicId}/quiz`);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch quiz for topic ${topicId}:`, error);
      throw error;
    }
  },

  // Search topics
  search: async (query: string): Promise<SearchResult> => {
    try {
      const response = await apiClient.get('/master/search', {
        params: { q: query }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to search topics:', error);
      throw error;
    }
  },

  // Get themes
  getThemes: async (): Promise<Theme[]> => {
    try {
      const response = await apiClient.get('/master/themes');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch themes from API:', error);
      throw error;
    }
  },
};
